// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2XDrK","label":"Labeled_label__1Yfa-","divider":"Labeled_divider__3X610"};